import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/dashboard/headerRightBg.png';
import headerRightBg375 from '../images/dashboard/headerRightBg375.png';
import DashboardWidgetsManWoman from '../images/dashboard/DashboardWidgetsManWoman.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import CloudUpArrow from '../images/dashboard/CloudUpArrow.svg';
import PersonTie from '../images/dashboard/PersonTie.svg';
import FiveNodes from '../images/dashboard/FiveNodes.svg';
import halfSectionGradient from '../images/dashboard/halfSectionGradient.png';
import fullWidthSplitBg from '../images/dashboard/fullWidthSplitBg.png';
import LaptopDashboard from '../images/dashboard/LaptopDashboard.png';
import WantToSeeHow from '../components/WantToSeeHow';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const DashboardHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `75px`, paddingBottom: `40px`}}>
		<h1>Dashboard</h1>
		<p>Streamlined lender workflows<br />built for collaboration</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 85%;
		margin-bottom: 1em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 484px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
			margin-bottom: 2em;
		}
	}
`;

const DashboardWidgetsManWomanFigure =
	<HeaderBottomContentFigure>
		<DashboardWidgetsManWoman alt='Man at desk looking at connected apps' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`
	&.full-width-split {

		@media (${(props) => props.theme.mediumUp}) {
			& .responsivePadding#alignStretch {
				align-items: stretch;

				& article {
					align-items: center;
					display: flex;
				}
			}
		}

		& figure#laptopWithDashboard {
			background-color: #3ed8c3;
			background-image: ${(props) => `url('${halfSectionGradient}')`};
			align-items: center;
			padding-top: 40px;
			padding-bottom: 40px;

			@media (${(props) => props.theme.mediumUp}) {
				padding-left: 40px;
				padding-top: 60px;
				padding-bottom: 60px;
			}

			@media (${(props) => props.theme.largeUp}) {
				padding-left: 60px;
				padding-top: 70px;
				padding-bottom: 70px;
			}

			@media all and (-ms-high-contrast: none) {
				& img {
					max-width: 347px;
					max-height: 240px;
				}
			}

			@media (${(props) => props.theme.smallUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 530px;
					max-height: 267px;
				}
			}

			@media (${(props) => props.theme.mediumUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 285px;
					max-height: 144px;
				}
			}

			@media (${(props) => props.theme.largeUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 380px;
					max-height: 192px;
				}
			}

			@media (${(props) => props.theme.xLargeUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 482px;
					max-height: 243px;
				}
			}
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.whiteLeftLtGreenRight {
			background-image: ${(props) => `url('${fullWidthSplitBg}')`};
		}
	}
`;

const FeaturesAndBenefitsSyle = { marginBottom: '0' };

const DashboardPage = (props: any) => {
	return (
	<Layout
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgPosition={'right top'}

		headerSplashBg={headerRightBg}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPositionLarge={'center -80px'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={DashboardWidgetsManWomanFigure}
		headerContentClass={'product'}
		headerContent={DashboardHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='Dashboard - Loan Origination Platform'
		metaDescription={'Consolidate your loan processes by managing files, credit decisions, analytics, reporting and so much more with our modern, mobile-first LOS.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'430px'}
		BodyClass={'Dashboard'}
	>
		<ProblemSolution
			problem={'Current loan origination processes are riddled with third party software products that have little to no integration capabilities, making the process cumbersome and prone to human error.'}
			solution={"Dashboard's seamless integrations consolidate the loan process to optimize underwriting efficiency while providing a cloud-based LOS to enhance your relationship with your customers."}
		/>
		<FeaturesAndBenefits
			extraStyle={FeaturesAndBenefitsSyle}
			solidBgColor = {'#3ed8c3'}

			leftIcon = {<CloudUpArrow alt='cloud, up arrow icon' style={{margin: `8px 0`}} />}
			leftHeading = {'Cloud-based\nplatform'}
			leftText={'Enjoy continuous improvement through scheduled system updates.'}

			middleIcon = {<PersonTie alt='person wearing a tie icon' style={{margin: `0`}} />}
			middleHeading = {'In-branch\ncredit applications'}
			middleText = {'Digitize the in-branch customer experience to qualify consumers for financial products.'}

			rightIcon = {<FiveNodes alt='five nodes icon' style={{margin: `2px 0`}} />}
			rightHeading = {'Centralized\nunderwriting queue'}
			rightText = {'Unify back-office workflows, allowing bank personnel to collaborate on loans in real-time.'}
		/>
		<Section className='full-width-split full-width whiteLeftLtGreenRight'>
			<div className='centeredWrapper'>
				<div className='responsivePadding row row-flush' id='alignStretch'>
					<article className='col-12 col-md-6'>
						<div className='product text-box'>
							<header>
								<h2>Supercharge your team to work better together</h2>
							</header>
							<p>Disjointed loan processes create inefficiencies amongst loan officers disengaging them from their customers. Modernize the loan process with a secure banking portal accessible from any device.</p>
							<p>Help your team move faster with built-in collaboration tools that make it easy for underwriters to store files, leave notes, and evaluate creditworthiness.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6 left-on-desktop' id='laptopWithDashboard'>
						<img src={LaptopDashboard} alt='laptop with MK Dashboard' />
					</figure>
				</div>
			</div>
		</Section>
		<div className='centeredWrapper'>
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default DashboardPage;
